// const CollectionUtil = (function () {
//     let isLoading = false;
//     let observer = null;

//     const resetState = () => {
//         const container = document.querySelector('#main-collection-product-grid');
//         if (container) {
//             container.dataset.currentPage = "1";
//             console.log('State Reset: Back to Page 1');
//         }
//         isLoading = false;
//         initInfiniteScroll();
//     };

//     const initInfiniteScroll = () => {
//         const trigger = document.querySelector('#infinite-scroll-trigger');
//         const pag = document.querySelector('.pagination-wrapper-standard');

//         if (!trigger) return;
//         if (pag) pag.style.setProperty('display', 'none', 'important');

//         if (observer) observer.disconnect();

//         // INCREASED ROOTMARGIN: 
//         // 1500px means it starts loading when the user is still 3-4 screens away from the bottom.
//         observer = new IntersectionObserver((entries) => {
//             if (entries[0].isIntersecting && !isLoading) {
//                 loadMore();
//             }
//         }, { rootMargin: '0px 0px 1500px 0px' }); 

//         observer.observe(trigger);

//         // INSTANT CHECK: In case the page is already scrolled down or trigger is visible
//         checkPosition();
//     };

//     // Backup function to force check if we need to load more immediately
//     const checkPosition = () => {
//         const trigger = document.querySelector('#infinite-scroll-trigger');
//         if (trigger && !isLoading) {
//             const rect = trigger.getBoundingClientRect();
//             if (rect.top <= window.innerHeight + 1500) {
//                 loadMore();
//             }
//         }
//     };

//     const loadMore = async () => {
//         const container = document.querySelector('#main-collection-product-grid');
//         if (!container || isLoading) return;

//         const totalPages = parseInt(container.dataset.totalPages);
//         const currentPage = parseInt(container.dataset.currentPage);
        
//         if (currentPage >= totalPages) return;

//         isLoading = true;
//         const loader = document.querySelector('#infinite-scroll-loader');
//         if (loader) loader.style.setProperty('display', 'block', 'important');

//         const nextPage = currentPage + 1;
//         const url = new URL(window.location.href);
//         url.searchParams.set('page', nextPage);

//         try {
//             const response = await fetch(url.toString());
//             const text = await response.text();
//             const html = new DOMParser().parseFromString(text, 'text/html');
            
//             const newItems = html.querySelectorAll('.collectionList__trending > *');
//             const currentGrid = document.querySelector('.collectionList__trending');

//             if (newItems.length > 0 && currentGrid) {
//                 newItems.forEach(item => {
//                     const node = item.cloneNode(true);
//                     // Remove theme hidden/animation classes if they cause delays
//                     node.style.opacity = "1"; 
//                     currentGrid.appendChild(node);
//                 });
//                 container.dataset.currentPage = nextPage;
//             }

//             if (nextPage >= totalPages && observer) {
//                 observer.disconnect();
//             } else {
//                 // If we just loaded a page, check if we are still near the bottom 
//                 // to load the NEXT one immediately (daisy-chaining)
//                 setTimeout(checkPosition, 100);
//             }
//         } catch (e) {
//             console.error("Fetch Error:", e);
//         } finally {
//             isLoading = false;
//             if (loader) loader.style.setProperty('display', 'none', 'important');
//         }
//     };

//     return {
//         run: () => {
//             initInfiniteScroll();

//             // Passive scroll listener for maximum responsiveness
//             window.addEventListener('scroll', checkPosition, { passive: true });

//             const gridWrapper = document.getElementById('collection-grid');
//             if (gridWrapper) {
//                 const mutationObserver = new MutationObserver((mutations) => {
//                     for (let mutation of mutations) {
//                         if (mutation.type === 'childList') {
//                             resetState();
//                             break;
//                         }
//                     }
//                 });
//                 mutationObserver.observe(gridWrapper, { childList: true });
//             }
//         }
//     };
// })();

// document.addEventListener('DOMContentLoaded', CollectionUtil.run);

const CollectionUtil = (function () {
    let isLoading = false;
    let observer = null;

    const initInfiniteScroll = () => {
        const trigger = document.querySelector('#infinite-scroll-trigger');
        if (!trigger) return;

        // Cleanup old observer to prevent double-loading
        if (observer) observer.disconnect();

        observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && !isLoading) {
                loadMore();
            }
        }, { rootMargin: '0px 0px 1000px 0px' }); 

        observer.observe(trigger);
        checkPosition();
    };

    const checkPosition = () => {
        const trigger = document.querySelector('#infinite-scroll-trigger');
        if (trigger && !isLoading) {
            const rect = trigger.getBoundingClientRect();
            if (rect.top <= window.innerHeight + 1000) {
                loadMore();
            }
        }
    };

    const loadMore = async () => {
        const container = document.querySelector('#main-collection-product-grid');
        if (!container || isLoading) return;

        const totalPages = parseInt(container.getAttribute('data-total-pages'));
        const currentPage = parseInt(container.getAttribute('data-current-page'));
        const sectionId = container.getAttribute('data-section-id');
        
        // STOP if we are at the end of the filtered results (e.g., page 3 of 3)
        if (currentPage >= totalPages) return;

        isLoading = true;
        const loader = document.querySelector('#infinite-scroll-loader');
        if (loader) loader.style.display = 'block';

        const nextPage = currentPage + 1;
        const url = new URL(window.location.href);
        
        // CRITICAL: These parameters ensure you get filtered items, not random ones
        url.searchParams.set('page', nextPage);
        url.searchParams.set('section_id', sectionId); 

        try {
            const response = await fetch(url.toString());
            const text = await response.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            
            // Selector must match your grid's inner container
            const newItems = html.querySelectorAll('.collectionList__trending > *');
            const currentGrid = document.querySelector('.collectionList__trending');

            if (newItems.length > 0 && currentGrid) {
                newItems.forEach(item => {
                    const node = item.cloneNode(true);
                    node.style.opacity = "1"; 
                    currentGrid.appendChild(node);
                });
                // Update current page so the script knows we are now on Page 2, 3, etc.
                container.setAttribute('data-current-page', nextPage);
            }

            // Disconnect if we've reached the end
            if (nextPage >= totalPages && observer) {
                observer.disconnect();
            }
        } catch (e) {
            console.error("Infinite Scroll Error:", e);
        } finally {
            isLoading = false;
            if (loader) loader.style.display = 'none';
        }
    };

    return {
        run: () => {
            initInfiniteScroll();
            window.addEventListener('scroll', checkPosition, { passive: true });

            // Watch for when filters change the HTML to re-bind the trigger
            const gridWrapper = document.getElementById('collection-grid');
            if (gridWrapper) {
                const mutationObserver = new MutationObserver(() => {
                    initInfiniteScroll(); 
                });
                mutationObserver.observe(gridWrapper, { childList: true });
            }
        }
    };
})();

// Run on page load
document.addEventListener('DOMContentLoaded', CollectionUtil.run);